var version = "22.0.1";
export { version };
